export default __webpack_public_path__ + "static/media/logo.b002e05d.svg";